import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import {
  ArticleReview,
  ArticleReviewQuery,
  listArticleReviews,
} from "#/services/articleReviews";

type ArticleReviewsListOptions = {
  enabled?: boolean;
};

export function useArticleReviewsList(
  params?: ArticleReviewQuery,
  options?: ArticleReviewsListOptions
) {
  const hasParams = Boolean(params?.articleId || params?.revisionId);

  return useQuery<ArticleReview[]>({
    queryKey: qk.articleReviews(params),
    queryFn: ({ signal }) => listArticleReviews(params, { signal }),
    enabled: options?.enabled ?? hasParams,
    staleTime: 30_000,
    refetchOnMount: "always",
  });
}

export default useArticleReviewsList;
